import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { customColorSets } from '../../../utils/custom-color-sets';

@Component({
    selector: 'neu-charts-tree',
    template: `<div class="chart-container" *ngIf="data && (data.length > 0)">
    <ngx-charts-tree-map
        [scheme]="colorScheme"
        [results]="data"
        (select)="mSelectedEvent($event)">
    </ngx-charts-tree-map>
</div>
<no-data *ngIf="(!data) || (data.length <= 0)"></no-data>`,
    styles: [``]
})
export class TreeComponent implements OnInit {

    @Input('data') data: any;

    @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

    colorScheme = customColorSets.find(s => s.name == 'palatte');

    constructor() { }

    ngOnInit() {}

    mSelectedEvent(event: any) {
        this.onSelect.emit(event);
    }

}
